import { render, staticRenderFns } from "./TabContent2.vue?vue&type=template&id=63c34c4c"
import script from "./TabContent2.vue?vue&type=script&lang=js"
export * from "./TabContent2.vue?vue&type=script&lang=js"
import style0 from "./TabContent2.vue?vue&type=style&index=0&id=63c34c4c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports